// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wenn ein Hash vorhanden ist (#about, #services)
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);

      if (el) {
        const yOffset = 80; // Höhe der Navbar
        const y =
                  el.getBoundingClientRect().top + window.pageYOffset - yOffset;

        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 80);

        return;
      }
    }

    // Standard: immer nach oben scrollen
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
